import { combineReducers } from 'redux';

import leaderboardUiReducer from './leaderboardUiReducer';
import leaderboardDataReducer from './leaderboardDataReducer';

export default combineReducers({
  ui: leaderboardUiReducer,
  data: leaderboardDataReducer,
});
